import React, { memo, useContext } from 'react';
import { compact } from 'lodash';
import { routes } from 'constants/config';
import lessonCard from 'images/lesson_card.svg';
import { FilterContext } from 'components/shared/FilterContext/index';
import DataCardHeader from '../_shared/DataCardHeader';
import Count from '../_shared/Count';
import WeeklyAssignmentsChart from './WeeklyAssignmentsChart';
import DateRangeFormat from '../_shared/DateRangeFormat';

const CompletedAssignmentsModule = memo(({ i18n }) => {
  const { params: filterParams } = useContext(FilterContext);
  return (
    <section className="DataCard DataCard--vertical f-1 mr-32 h-100">
      <DataCardHeader
        title={i18n.assignments.completed.title}
        subtitle={
          filterParams.start_date || filterParams.end_date ? (
            <DateRangeFormat
              start={filterParams.start_date}
              end={filterParams.end_date}
            />
          ) : (
            i18n.timeframes.last_90_days
          )
        }
        downloadLink={compact([
          routes.INSIGHTS.COMPLETED_ASSIGNMENTS.REPORT,
          $.param(filterParams),
        ]).join('?')}
        reportTitle={i18n.assignments.completed.report.title}
        pendoClassName="trk_link_learning_all-completed-assignments-download"
      >
        <Count
          route={routes.INSIGHTS.COMPLETED_ASSIGNMENTS.COUNT}
          imgSrc={lessonCard}
          imgDescription={`${i18n.assignments.completed.title}:`}
        />
      </DataCardHeader>
      <div className="DataCard-main">
        <WeeklyAssignmentsChart i18n={i18n} />
      </div>
    </section>
  );
});

export default CompletedAssignmentsModule;
